<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'product'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">{{$t('common.allproducts')}}</h1>
						</div>
						<div class="add-product-wrapper add-product-wrapper-g-2 add-product-gap-20">
							<div class="product-container mobile-height-auto">
								<div class="a-img-blcok">
									<img src="../../assets/images/gift.png" class="d-icon" />
								</div>
								<div class="a-num">{{total}}</div>
								<div class="a-txt">{{$t('common.uploadedproducts')}}</div>
							</div>
							<div class="add-inner mobile-height-auto" @click="openPage('addProduct')">
								<div>
									<div class="a-img-blcok">
										<img src="../../assets/images/add_product.png" class="d-icon" />
									</div>
									<div class="a-txt">{{$t('common.productlibrary')}}</div>
								</div>
							</div>
						</div>
						<div class="search-container">
							<div class="search-block">
								<el-input :placeholder="$t('common.productname')" v-model="queryparam.productName" clearable>
								</el-input>
							</div>
							<div class="search-btns" style="margin-top: 5px;">
								<el-button type="primary" size="small" @click="getStoreProduct">
									{{$t('button.search')}}
								</el-button>
								<el-button size="small" @click="resetQuery">{{$t('button.reset')}}
								</el-button>
							</div>
						</div>
						<div class="table-wrap">
							<el-table :data="storeProductList" style="width: 100%" v-loading="tableLoading"
								:empty-text="$t('empty.nodata')">
								<el-table-column prop="date" :label="$t('table.img')" width="200">
									<template v-slot="scope">
										<el-image style="width: 80px; height: 80px" :src="scope.row.icon" fit="fill">
										</el-image>
									</template>
								</el-table-column>
								<el-table-column prop="name" :label="$t('common.productname')" width="210">
									<template v-slot="scope">
										<span>{{scope.row.productName}}</span>
									</template>
								</el-table-column>
								<el-table-column :label="$t('table.category')" width="190">
									<template v-slot="scope">
										<span>{{scope.row.typeName}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="stock" :label="$t('table.stock')" width="150">
								</el-table-column>
								<el-table-column prop="discountPrice" :label="$t('table.price')" width="150">
									<template v-slot="scope">
										<span>${{scope.row.discountPrice}}</span>
									</template>
								</el-table-column>
								<!-- 发表 -->
								<el-table-column :label="$t('table.published')" width="200">
									<template v-slot="scope">
										<el-switch v-model="scope.row.sta"
											@change="handleStatusChange(scope.row, 'sta')"></el-switch>
									</template>
								</el-table-column>

								<!-- 精选 hot_flag -->
								<el-table-column :label="$t('table.featured')" width="200">
									<template v-slot="scope">
										<el-switch v-model="scope.row.hotFlag"
											@change="handleStatusChange(scope.row, 'hotFlag')"></el-switch>
									</template>
								</el-table-column>

								<!-- 直通车 -->
								<el-table-column :label="$t('table.throughtrainpromotion')" width="150">
									<template v-slot="scope">
										<el-switch v-model="scope.row.ztcFlag"
											@change="handleStatusChange(scope.row, 'ztcFlag')"></el-switch>
									</template>
								</el-table-column>

								<el-table-column fixed="right" :label="$t('table.options')" width="190">
									<template slot-scope="scope">
										<div style="float: left;margin-right: 10px;">
											<el-button type="text" size="small">
												{{$t('table.view')}}
											</el-button>
											<!--总后台 0上架  1下架  商户后台 0下 1上-->
											<el-button type="text" size="small">{{$t('table.grounding')}}
											</el-button>
										</div>

									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="table-mobile-wrapper">
							<div class="product-infos-wrapper" v-for="item in storeProductList">
								<div class="tool-btns">
									<el-dropdown>
										<div class="btn">
											<i class="el-icon-more"></i>
										</div>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item>
												<div @click.stop="handleStatusChangeMobile(item, 'sta')">
													<span v-if="item.sta">{{$t('table.takedown')}}</span>
													<span v-else>{{$t('table.putonsale')}}‌‌</span>
												</div>
											</el-dropdown-item>
											<el-dropdown-item>
												<div @click.stop="handleStatusChangeMobile(item, 'hotFlag')">
													<span v-if="item.hotFlag">{{$t('table.cancelfeatured')}}</span>
													<span v-else>{{$t('table.featured')}}</span>
												</div>
											</el-dropdown-item>
											<el-dropdown-item>
												<div @click.stop="handleStatusChangeMobile(item, 'ztcFlag')">
													<span v-if="item.ztcFlag">{{$t('table.cancelthroughtrainpromotion')}}</span>
													<span v-else>{{$t('table.throughtrainpromotion')}}</span>
												</div>
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
								<div class="p-item-image">
									<img :src="item.icon" class="img-responsive" />
								</div>
								<div class="p-item-desc-container">
									<div class="p-item-title">{{ item.productName }}</div>
									<div class="p-item-price">
										<div class="p-price">
											$<span>{{ item.discountPrice }}</span>
										</div>
										<div>
											<el-tag type="success">stock：{{ item.stock }}</el-tag>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 分页组件 -->
						<div class="page-contrainer d-flex">
							<el-pagination :page-count="isMobile ? 4 : 10" background layout="prev, pager, next" :total="total"
								 :current-page.sync="queryparam.pageNum"
								@current-change="getStoreProduct">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>


</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		selectStoreProduct,
		updateProductStatus
	} from "@/api/storeProduct";

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				queryparam: {
					productName: ''
				},
				storeProductList: [],
				tableLoading: false,
				tableData: [],
				total: 1,
				pageNo: 1,
				isMobile:false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getStoreProduct();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			resetQuery() {
				this.queryparam.productName = '';
				this.getStoreProduct();
			},

			// 更新商品状态
			handleStatusChange(row, field) {
				if (!row.storeProductNo) {
					this.$message.error('Invalid product ProductNo');
					return;
				}

				const params = {
					storeProductNo: row.storeProductNo,
					type: field,
					value: row[field] ? 1 : 0 // 将 true/false 转换为 1/0
				};

				updateProductStatus(params).then(res => {
					if (res.code === 200) {
						this.$message({
							message: `updated successfully`,
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
						row[field] = !row[field]; // 回滚
					}
				}).catch(err => {
					console.error(err);
					row[field] = !row[field]; // 回滚
				});
			},

			// 更新商品状态
			handleStatusChangeMobile(row, field) {
				if (!row.storeProductNo) {
					this.$message.error('Invalid product ProductNo');
					return;
				}
			
				const params = {
					storeProductNo: row.storeProductNo,
					type: field,
					value: row[field] == 1 ? 0 : 1 // 将 true/false 转换为 1/0
				};
			
				updateProductStatus(params).then(res => {
					if (res.code === 200) {
						this.getStoreProduct();
						this.$message({
							message: `updated successfully`,
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
						row[field] = !row[field]; // 回滚
					}
				}).catch(err => {
					console.error(err);
					row[field] = !row[field]; // 回滚
				});
			}
			,
			getStoreProduct() {
				selectStoreProduct(this.queryparam).then(res => {
					if (res.code === 200) {
						this.storeProductList = res.rows.map(item => ({
							...item,
							sta: item.sta === 1, // 1 -> true, 0 -> false
							hotFlag: item.hotFlag === 1,
							ztcFlag: item.ztcFlag === 1
						}));
						this.total = res.total;
					} else {
						return false;
					}
				});
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/product.css");

	@media (max-width: 767px) {

		.add-product-wrapper .mobile-height-auto,
		.add-product-wrapper .mobile-height-auto {
			height: auto;
		}

		.add-product-gap-20 {
			gap: 0 20px;
		}

		.search-btns {
			width: 204px;
		}
	}
	.tool-btns {
		position: absolute;
		top: 5px;
		right: 12px;
		z-index: 3;
	}
</style>
